/**
 * This palette defines additional theme colors not supported by AppTheme's IPalette interface.
 * These colors are intended to be used via semantic definitions rather than directly for adhoc purposes.
 * Please make use of existing colors when possible, instead of adding new colors to this palette.
 */
export var ExtendedThemePalette = {
    red: '#A80000',
    redDark: '#442726',
    redLight: '#F1707B',
    redLighter: '#FDE7E9',
    orange: '#D83B01',
    orangeDark: '#AF2A0F',
    orangeLight: '#FED9CC',
    yellow: '#FCE100',
    yellowDark: '#433519',
    yellowLight: '#FFF4CE',
    green: '#107C10',
    greenDark: '#393D1B',
    greenLight: '#92C353',
    greenLighter: '#DFF6DD',
};
//# sourceMappingURL=extendedThemePalette.js.map